module.exports = "/_next/static/images/step2-11c8aa23eca22affa967fc840e8a7ccc.png";